import { createSelector } from 'reselect';

const getPriceConcessionState = state => state.pricing.priceConcession;

export const selectPriceConcessionAcceptReasons = createSelector(
  getPriceConcessionState,
  priceConcession => priceConcession.acceptReasons,
);

export const selectExternalLoanLockCustomAdjustmentsOptions = createSelector(
  selectPriceConcessionAcceptReasons,
  acceptReasons => acceptReasons.map(({ id, name }) => ({ value: id, name })),
);
